import ActivityType from "./ActivityType";
import Hospital from "../models/Hospital";
import Random from "../core/Random";
import UserType from "./UserType";
import NOKUser from "../models/NOKUser";

export default class HospitalUtils {
  public constructor() {}
  public static getHospitals(
    hospitals: Array<Hospital>,
    admins: Array<NOKUser>
  ): Array<Hospital> {
    let filteredHospitals: Array<Hospital> = admins
      .map((element) => element.hospital)
      .toList();

    filteredHospitals = hospitals
      .where((element) => !filteredHospitals.contains(element))
      .toList();

    return filteredHospitals;
  }
  public static getMaskedSSN(ssn: string): string {
    let ssnNumber: string = ssn;

    // ssn number should be masked and last 3 digits should be visible

    if (ssnNumber !== null && ssnNumber.length > 3) {
      ssnNumber =
        "***-**-*" +
        ssnNumber.substring(ssnNumber.length - 3, ssnNumber.length);
    }

    return ssnNumber;
  }
  public static generateSearchId(hospital: Hospital): string {
    //  generate 8 digit random string

    let searchId: string = hospital.name.replaceAll(" ", "").toLowerCase();

    let chars: string =
      "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    let rnd: Random = new Random();

    //  crate 8 length random string using for loop

    let randomString: string = "";

    for (let i: number = 0; i < 8; i++) {
      randomString += chars[rnd.nextInt(chars.length)];
    }

    return searchId + "-" + randomString.toLowerCase();
  }
  public static to(n: number): Array<number> {
    let res: Array<number> = [];

    for (let x: number = 1; x <= n; x++) {
      res.add(x);
    }

    return res;
  }
  public static getCustomActivityType(user: NOKUser): Array<ActivityType> {
    let activityTypes: Array<ActivityType> = [];

    if (user !== null) {
      if (user.userType === UserType.Staff) {
        activityTypes.add(ActivityType.Login);

        activityTypes.add(ActivityType.Request);
      } else {
        activityTypes = ActivityType.values;
      }
    } else {
      activityTypes = ActivityType.values;
    }

    return activityTypes;
  }
  public static getFormattedMobileNumber(mobileNumber: string): string {
    if (mobileNumber === null || mobileNumber.isEmpty) {
      return "";
    }

    let formattedMobileNumber: string = mobileNumber;

    if (mobileNumber.length === 10) {
      if (mobileNumber.startsWith("+1")) {
        formattedMobileNumber =
          "(" +
          mobileNumber.substring(0, 3) +
          ") " +
          mobileNumber.substring(3, 6) +
          "-" +
          mobileNumber.substring(6, 10);
      } else {
        formattedMobileNumber =
          "+1" +
          "(" +
          mobileNumber.substring(0, 3) +
          ") " +
          mobileNumber.substring(3, 6) +
          "-" +
          mobileNumber.substring(6, 10);
      }
    }

    return formattedMobileNumber;
  }
}
